<payee-popup
  [heading]="titleKey | translate"
  [description]="descriptionKey | translate"
>
  @if (step() === "code") {
    @if (!has2FA && qrCodeDataUrl()) {
      <div class="qr-code flex column vcenter">
        <img
          alt=""
          width="200"
          height="200"
          [src]="qrCodeDataUrl()"
        />
        @if (secret()) {
          <div class="secret">
            <span class="secret-label">{{ "TWO_FACTOR_DIALOG.SECRET_LABEL" | translate }}</span>
            <code>{{ secret() }}</code>
          </div>
        }
      </div>
    }
    <form
      class="code-form flex column"
      [formGroup]="codeForm"
      (ngSubmit)="onSubmitCode()"
    >
      <payee-otp-form-field
        width="max"
        formControlName="code"
        (completed)="onSubmitCode()"
      >
        <span payee-label>{{ "TWO_FACTOR_DIALOG.CODE_LABEL" | translate }}</span>
        @if (code.dirty || code.touched) {
          <ng-container payee-error>
            @if (code.hasError("required") || code.hasError("pattern")) {
              <mat-error>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</mat-error>
            }
            @if (code.hasError("invalidCode")) {
              <mat-error>{{ "TWO_FACTOR_DIALOG.INVALID_CODE" | translate }}</mat-error>
            }
          </ng-container>
        }
      </payee-otp-form-field>
    </form>
  }

  <ng-template #payeePopupSubmitTemplate>
    @if (step() === "confirm") {
      <button
        payee-button
        width="max"
        [color]="primaryColor"
        [loading]="loading()"
        [disabled]="loading()"
        (click)="onPrimary()"
      >
        {{ (has2FA ? "TWO_FACTOR_DIALOG.DISABLE.CONFIRM" : "TWO_FACTOR_DIALOG.ENABLE.CONFIRM") | translate }}
      </button>
    } @else {
      <button
        payee-button
        width="max"
        [color]="primaryColor"
        [loading]="loading()"
        [disabled]="loading() || codeForm.invalid"
        (click)="onSubmitCode()"
      >
        {{ (has2FA ? "TWO_FACTOR_DIALOG.DISABLE.SUBMIT" : "TWO_FACTOR_DIALOG.ENABLE.SUBMIT") | translate }}
      </button>
    }
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      mat-dialog-close
      [isBorderButton]="true"
      [disabled]="loading()"
    >
      {{ "CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
